/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_QuantityInputs */

const vi_product_stock_quantity = /** @type {(inputs: Product_Stock_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn`)
};

/**

* @param {Product_Stock_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_quantity = /** @type {((inputs?: Product_Stock_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_quantity(inputs)
});